import React, {useEffect, useState} from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import $ from "jquery";

import MapImg from "../../images/map.png";
import CardImg from "../../images/card-02.jpg";
import AuthorImg from "../../images/Author.svg";
import ContentModule from "../../modules/content_module";
import CTABtnModule from "../../modules/cta_btn_module";
import ImageModule from "../../modules/image_module";
import { PopularSearch_Areas } from "../../common/constant"
import { PropertySearchUrl } from "../../common/utils/property_utils"

import "./PropertySidebar.scss"



const PropertySidebar = ({onViewChange, searchParams}) => {

    // const [scroll, setScroll] = useState(false);

    // useEffect(() => {
    //     const rightside_sticky = document.querySelector(".rightside_sticky");
    //     const get_top_pos = $('#rightside_sticky').position().top

    //     window.addEventListener("scroll", () => {

    //         if(window.scrollY > get_top_pos){
    //             rightside_sticky.classList.add("sticky-bar");
    //         } else{
    //             rightside_sticky.classList.remove("sticky-bar");
    //         }


    //     })
    // }, [])

    const data = useStaticQuery(graphql`
        query PropertySearchSidebar{
            glstrapi {
                propertySearch {
                    rightside_bar {
                        show_sidebar
                        recommended_searches
                        content_card_cta {
                            id
                            title
                            image {
                                url
                                alternativeText
                            }
                            content
                            cta_link
                            cta_label
                        }
                        card_image {
                            id
                            title
                            content
                            image {
                                url
                                alternativeText
                            }
                            cta_link
                            cta_label
                        }
                        campaign_banner {
                            id
                            title
                            content
                            image {
                                url
                                alternativeText
                            }
                            cta_link
                            cta_label
                        }
                    }
                }
            }
        }
    `)

    var rightside_bar = data?.glstrapi.propertySearch.rightside_bar;

    //console.log("rightside_bar", rightside_bar)

    var property_url = PropertySearchUrl(searchParams.department, searchParams?.search_type)
    var property_text = "Property";
    if(searchParams.department === "commercial"){
        property_text = "Commercial property";
    }

    return(
        <React.Fragment>
        {rightside_bar?.show_sidebar && 
            <section className="prop_sidebar">
                <div className="map-img">
                    <a href="javascript:;" onClick={() => onViewChange(true)}>
                        <img src={MapImg} alt="map_view"/>
                        <span>Map View</span>
                    </a>
                </div>

                {rightside_bar?.content_card_cta && 
                <section className="listing-sidebar-card">
                    <div className="listing-sidebar-card-wrapper small-img">
                        {rightside_bar?.content_card_cta?.image && 
                            <ImageModule ImageSrc={rightside_bar?.content_card_cta?.image} renderer="srcSet" />
                        }
                        <div className="listing-sidebar-card-content">
                            {rightside_bar?.content_card_cta?.title &&
                            <div className="title">
                                <h3>{rightside_bar?.content_card_cta?.title}</h3>
                            </div>
                            }

                            {rightside_bar?.content_card_cta?.content &&
                            <div className="content">
                                {<ContentModule Content={rightside_bar?.content_card_cta?.content}/> }
                            </div>
                            }

                            {rightside_bar?.content_card_cta?.cta_label &&
                            <div className="btn-wrapper">
                                <Link className="btn btn-outline" to={rightside_bar?.content_card_cta?.cta_link}>{rightside_bar?.content_card_cta?.cta_label}</Link>
                            </div>
                            }
                        </div>
                    </div>
                </section>
                }

                {rightside_bar?.card_image && 
                <div className="card_wrapper">
                    {rightside_bar?.card_image?.image && 
                        // <img src={rightside_bar?.card_image?.image.url} alt={rightside_bar?.card_image?.image} className="card_img" />

                        <ImageModule ImageSrc={rightside_bar?.card_image?.image} renderer="srcSet" classNames="card_img"  />
                    }
                    <span className="transp_bg"></span>
                    <div className="card_inner">
                        {rightside_bar?.card_image?.title && 
                            <h3>{rightside_bar?.card_image?.title}</h3>
                        }
                        {rightside_bar?.card_image?.content && <ContentModule Content={rightside_bar?.card_image?.content}/> }

                        {rightside_bar?.card_image?.cta_label && rightside_bar?.card_image?.cta_link && (() => {
                            const link = rightside_bar.card_image.cta_link;
                            const isExternal = /^https?:\/\//.test(link) && !link.includes(typeof window !== "undefined" && window.location.hostname);
                            return (
                                <Link
                                className="btn btn-outline"
                                to={link}
                                {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                >
                                {rightside_bar.card_image.cta_label}
                                </Link>
                            );
                        })()}
                    </div>
                </div>
                }

                <div className="sidebar-sticky">
                    <section className="listing-sidebar-card reco_search">
                        <div className="listing-sidebar-card-wrapper">
                            <div className="title">
                                <h3>Recommended Searches</h3>
                            </div>
                            <div className="content">
                                {/* {<ContentModule Content={rightside_bar?.recommended_searches}/> } */}
                                <ul className="recommend_srch">
                                    {PopularSearch_Areas.map((item) => {
                                        return(<>
                                            {
                                                <li><Link to={`${property_url}in-${item.value}/`}>{property_text} {searchParams.action} in {item.label}</Link></li>
                                            }
                                            
                                        </>)
                                    })}
                                </ul>
                            </div>
                        </div>
                    </section>

                    {rightside_bar?.campaign_banner && 
                    <section className="listing-sidebar-card">
                        <div className="listing-sidebar-card-wrapper">
                            {rightside_bar?.campaign_banner?.image && 
                                <ImageModule ImageSrc={rightside_bar?.campaign_banner?.image} renderer="srcSet" />
                            }

                            <div className="listing-sidebar-card-content">
                                {rightside_bar?.campaign_banner?.title && 
                                <div className="title">
                                    <h3>{rightside_bar?.campaign_banner?.title}</h3>
                                </div>
                                }

                                {rightside_bar?.campaign_banner?.content && 
                                <div className="content">
                                    <p>{<ContentModule Content={rightside_bar?.campaign_banner?.content}/> }</p>
                                </div>
                                }

                                {rightside_bar?.campaign_banner?.cta_label && 
                                <div className="btn-wrapper">
                                    <Link className="btn btn-outline" to={rightside_bar?.campaign_banner?.cta_link}>{rightside_bar?.campaign_banner?.cta_label}</Link>
                                </div>
                                }
                            </div>
                        </div>
                    </section>
                    }
                </div>

            </section>
        }
        </React.Fragment>
    )
}
export default PropertySidebar;